import type { FunctionComponent } from 'react';

import useNoApplicableLoans from './useNoApplicableLoans';

const NoApplicableLoans: FunctionComponent = function () {
  const { maxLoan, maxDeposit, jobTotal, deficit, workTypeNotAllowed } =
    useNoApplicableLoans();

  return (
    <div className="flex flex-col px-6 py-4 rounded rounded-lg border border-violet-200 bg-violet-100 text-violet-200 text-16-24">
      {workTypeNotAllowed ? (
        <p>
          Unfortunately, there are no loan products available for this type of
          job currently.
        </p>
      ) : (
        <p>
          Unfortunately, there are no loan products available for this job. The
          maximum loan you can take out is {maxLoan}, and the maximum deposit
          allowed by the lender is {maxDeposit}. With a job total of {jobTotal},
          this would leave a deficit of {deficit}. Please contact your
          tradesperson to discuss their quote
        </p>
      )}
    </div>
  );
};

export default NoApplicableLoans;
